import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.4952 7.13774C18.5666 10.7247 17.3374 15.3114 13.7504 17.3819C10.1635 19.4533 5.57682 18.2241 3.50624 14.6372C1.4349 11.0502 2.66405 6.46279 6.25102 4.39295C9.83799 2.32162 14.4246 3.55077 16.4952 7.13774Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0951 13.3186C13.3559 10.8415 11.4091 7.46904 11.4421 3.52734M8.55931 18.2472C8.28333 13.77 6.33648 10.3976 2.90625 8.45596",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }